import type { PdfComponent } from '../../TermsAndConditionsRender/components/typed';

export const SECTION38: PdfComponent = {
  type: 'section',
  id: 's38',
  title: '38. Governing Law',
  content: [
    {
      type: 'altText',
      id: 's38bullets',
      content: [
        'This Agreement and any dispute or claim (including non-contractual disputes or claims) arising out of or in connection with it, its subject matter or formation shall be governed by and construed in accordance with the law of England and Wales.',
      ],
      boldFirst: false,
    },
  ],
};
